var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16146 7H11.8385C12.3657 6.99998 12.8205 6.99997 13.195 7.03057C13.5904 7.06287 13.9836 7.13419 14.362 7.32698C14.9265 7.6146 15.3854 8.07355 15.673 8.63803C15.8658 9.01641 15.9371 9.40963 15.9694 9.80498C16 10.1795 16 10.6344 16 11.1615V15.8386C16 16.3657 16 16.8205 15.9694 17.195C15.9371 17.5904 15.8658 17.9836 15.673 18.362C15.3854 18.9265 14.9265 19.3854 14.362 19.673C13.9836 19.8658 13.5904 19.9371 13.195 19.9694C12.8205 20 12.3657 20 11.8385 20H4.16145C3.63431 20 3.17954 20 2.80498 19.9694C2.40963 19.9371 2.01641 19.8658 1.63803 19.673C1.07355 19.3854 0.614604 18.9265 0.326984 18.362C0.13419 17.9836 0.0628736 17.5904 0.0305726 17.195C-2.98917e-05 16.8205 -1.5696e-05 16.3657 7.59377e-07 15.8386V11.1614C-1.5696e-05 10.6343 -2.98899e-05 10.1795 0.0305726 9.80498C0.0628736 9.40963 0.13419 9.01641 0.326984 8.63803C0.614604 8.07355 1.07355 7.6146 1.63803 7.32698C2.01641 7.13419 2.40963 7.06287 2.80498 7.03057C3.17953 6.99997 3.63434 6.99998 4.16146 7ZM8 13C7.44772 13 7 13.4477 7 14V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V14C9 13.4477 8.55229 13 8 13Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V7H10V4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4V7H4V4Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.77f21161cdaec05359434052620446ed.svg";
export { ForwardRef as ReactComponent };